import styled from 'styled-components'

export const NumberedListWrap = styled.ul ``;